import { createAsyncThunk } from "@reduxjs/toolkit";
import { axiosAuthRequest } from "request/request";
import { toast } from "react-toastify";

export const getTeacherGroups = createAsyncThunk(
  "teacher/getTeacherGroups",
  async (teacherOrHeadGroupPath, { rejectWithValue }) => {
    try {
      let url = {
        curator: `education/v1/teacher-group`,
        groupHead: `education/v1/head-course-group`,
      };
      const { data } = await axiosAuthRequest.get(url[teacherOrHeadGroupPath]);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getTeacherSchedule = createAsyncThunk(
  "teacher/getTeacherSchedule",
  async ({ start_date, end_date }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/teacher-schedule?start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJournalOptions = createAsyncThunk(
  "teacher/getJournalOptions",
  async (_, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/journal-options`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJournalDates = createAsyncThunk(
  "teacher/getJournalDates",
  async (
    { group_id, subject_id, semester_id, curriculum_id },
    { rejectWithValue }
  ) => {
    try {
      let url = `schedule/v1/journal-dates?group_id=${group_id}&subject_id=${subject_id}&semester_property_id=${semester_id}&curriculum_id=${curriculum_id}`;
      const { data } = await axiosAuthRequest.get(url);

      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getJournalStudents = createAsyncThunk(
  "teacher/getJournalStudents",
  async (
    { group_id, subject_id, semester_id, curriculum_id },
    { rejectWithValue }
  ) => {
    try {
      let url = `schedule/v1/journal-students?group_id=${group_id}&subject_id=${subject_id}&semester_property_id=${semester_id}&curriculum_id=${curriculum_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getMarkTypes = createAsyncThunk(
  "teacher/getMarkTypes",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/mark-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const makeJournalMark = createAsyncThunk(
  "teacher/makeJournalMark",
  async ({ closeModal, ...body }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/student-assignment-marks`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const makeJournalSemesterMark = createAsyncThunk(
  "teacher/makeJournalSemesterMark",
  async ({ closeModal, ...body }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/student-semester-marks`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteJournalMark = createAsyncThunk(
  "teacher/deleteJournalMark",
  async ({ closeModal, mark_id }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/mark?mark_id=${mark_id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteJournalSemesterMark = createAsyncThunk(
  "teacher/deleteJournalSemesterMark",
  async ({ closeModal, mark_id }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/semester-mark?mark_id=${mark_id}`;
      const { data } = await axiosAuthRequest.delete(url);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const makeJournalAssignmentData = createAsyncThunk(
  "teacher/makeJournalAssignmentData",
  async ({ closeModal, ...body }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/assignment-data`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentsAttendance = createAsyncThunk(
  "teacher/getStudentsAttendance",
  async (groupId, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/student-attendance?group_id=${groupId}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentDiary = createAsyncThunk(
  "teacher/getStudentDiary",
  async (
    { group_id, student_id, start_date, end_date },
    { rejectWithValue }
  ) => {
    try {
      let url = `schedule/v1/student-diary?group_id=${group_id}&student_id=${student_id}&start_date=${start_date}&end_date=${end_date}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getGroupSubjects = createAsyncThunk(
  "teacher/getGroupSubjects",
  async (group_id, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/group-subjects?group_id=${group_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getStudentsRating = createAsyncThunk(
  "teacher/getStudentsRating",
  async ({ group_id, semester_id, subject_id }, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/students-rating?group_id=${group_id}&semester_id=${semester_id}&subject_id=${subject_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getAbsentTypes = createAsyncThunk(
  "teacher/getAbsentTypes",
  async (_, { rejectWithValue }) => {
    try {
      let url = `college/v1/absent-type`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const setStudentAbsent = createAsyncThunk(
  "teacher/setStudentAbsent",
  async (
    { closeModal, currentGroup, ...rest },
    { rejectWithValue, dispatch }
  ) => {
    try {
      let url = `schedule/v1/student-attendance`;
      const { data } = await axiosAuthRequest.put(url, rest);
      if (!data?.hasOwnProperty("error")) {
        closeModal();
        dispatch(getStudentsAttendance(currentGroup));
        toast.success("Иҷро шуд!");

        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getDiarySignatures = createAsyncThunk(
  "teacher/getDiarySignatures",
  async (
    { start_date, end_date, group_id, student_id },
    { rejectWithValue }
  ) => {
    try {
      let url = `schedule/v1/diary-signature?start_date=${start_date}&end_date=${end_date}&group_id=${group_id}&student_id=${student_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const makeTeacherDiarySignanure = createAsyncThunk(
  "teacher/makeTeacherDiarySignanure",
  async ({ behavior_id, ...rest }, { rejectWithValue, dispatch }) => {
    try {
      let url = `schedule/v1/teacher-diary-signature`;
      const { data } = await axiosAuthRequest.post(url, {
        behavior_id,
        ...rest,
      });
      if (!data?.hasOwnProperty("error")) {
        dispatch(getDiarySignatures(rest));
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getSignaturesBehaviorTypes = createAsyncThunk(
  "teacher/getSignaturesBehaviorTypes",
  async (_, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/behavior`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getParentActivity = createAsyncThunk(
  "teacher/getParentActivity",
  async (group_id, { rejectWithValue }) => {
    try {
      let url = `auth/v1/parent-activity?group_id=${group_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getCuratorLetters = createAsyncThunk(
  "teacher/getCuratorLetters",
  async (student_id, { rejectWithValue }) => {
    try {
      let url = `schedule/v1/newsletter?student_id=${student_id}`;
      const { data } = await axiosAuthRequest.get(url);
      if (!data?.hasOwnProperty("error")) {
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendCuratorLetters = createAsyncThunk(
  "teacher/sendCuratorLetters",
  async ({ handleSuccess, ...body }, { rejectWithValue, dispatch }) => {
    try {
      let url = `schedule/v1/newsletter`;
      const { data } = await axiosAuthRequest.post(url, body);
      if (!data?.hasOwnProperty("error")) {
        dispatch(getCuratorLetters(body?.student_id));
        handleSuccess();
        return data;
      } else {
        return;
      }
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
